/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  .fill {
    color: inherit;
  }
`
export default class PrivateIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" css={Color}>
        <g id="그룹_5587" data-name="그룹 5587" transform="translate(-252.858 -240.858)">
          <path id="빼기_130" data-name="빼기 130"
                d="M6.663,9.4H6.651A7.031,7.031,0,0,1,2.394,8.08L3.1,7.374A6.063,6.063,0,0,0,6.657,8.412a5.85,5.85,0,0,0,5.633-3.634.182.182,0,0,0,0-.155A5.9,5.9,0,0,0,9.07,1.4L9.82.654a6.968,6.968,0,0,1,3.388,3.565,1.143,1.143,0,0,1,0,.962A6.874,6.874,0,0,1,6.663,9.4Zm-.008-1.63A3.062,3.062,0,0,1,4.092,6.382L8.338,2.137a3.067,3.067,0,0,1-1.684,5.63ZM1.507,7.3h0A7.742,7.742,0,0,1,.1,5.181a1.159,1.159,0,0,1,0-.962A6.83,6.83,0,0,1,6.651,0H6.66A8.165,8.165,0,0,1,8.579.221l-.839.84A7.445,7.445,0,0,0,6.657.984,5.8,5.8,0,0,0,1.021,4.623a.182.182,0,0,0,0,.155A6.8,6.8,0,0,0,2.208,6.594l-.7.7ZM3.626,5.175h0a3.035,3.035,0,0,1-.036-.468A3.066,3.066,0,0,1,7.131,1.67l-3.5,3.5Z"
                transform="translate(255.203 245.419)" fill="#6f777e" stroke="rgba(0,0,0,0)" strokeMiterlimit="10"
                strokeWidth="1" className="fill"/>
          <path id="패스_44282" data-name="패스 44282"
                d="M4152.638,2710.448a.592.592,0,0,1-.418-1.01l9.121-9.121a.591.591,0,0,1,.836.836l-9.12,9.121A.591.591,0,0,1,4152.638,2710.448Z"
                transform="translate(-3895.464 -2455.336)" fill="#6f777e" className="fill"/>
        </g>
      </svg>
    )
  }
}
